import { render, staticRenderFns } from "./MonthlyThermalFailRateSummary.vue?vue&type=template&id=0bd057ee"
import script from "./MonthlyThermalFailRateSummary.vue?vue&type=script&lang=js"
export * from "./MonthlyThermalFailRateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports